export enum AlertActionsEnum {
	TakeAction = 'TakeAction',
	DismissAlert = 'DismissAlert',
}
